import React, { useContext, useEffect, useState } from "react";
import { Table, Form, InputGroup, Pagination, Button, Container } from "react-bootstrap";
import { Store } from "../../Store";

const TransactionHistory = () => {
  const { state } = useContext(Store);
  const { myOrders } = state;

  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (myOrders && myOrders.length > 0) {
      setTransactions(
        myOrders.sort((a, b) => new Date(b.date) - new Date(a.date))
      );
    } else {
      setTransactions([]);
    }
  }, [myOrders]);

  // Filtered Transactions
  const filteredTransactions = transactions.filter((transaction) =>
    Object.values(transaction).some(
      (value) =>
        value !== null &&
        value.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  // Pagination Logic
  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);
  const paginatedTransactions = filteredTransactions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formContainerStyle = {
    flex: 1,
    width: window.innerWidth < 768 ? '95vw' : 'auto',
  };

  return (
    <Container className="mt-3" style={{ width: window.innerWidth < 768 ? '95vw' : 'auto' }}>
       <h3 className='text-center text-primary border-bottom'>MY TRANSACTIONS</h3>
      {myOrders.length > 0 ? (
        <>
          <div className="container mt-4" style={formContainerStyle}>
            <h3 className="text-center">TRANSACTION HISTORY</h3>

            <div className="d-flex justify-content-between mb-2">
              <Form.Group controlId="entriesSelect">
                <Form.Label>Show</Form.Label>
                <Form.Control
                  as="select"
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  style={{ width: "auto", display: "inline-block" }}
                >
                  {[5, 10, 20, 50].map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </Form.Control>
                <span> entries</span>
              </Form.Group>
              <InputGroup className="search-bar" style={{ maxWidth: "200px" }}>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </InputGroup>
            </div>
            <div className="table-responsive" style={{ overflowX: 'auto' }}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Network</th>
                    <th>Beneficiary</th>
                    <th>Package</th>
                    <th>Amount</th>
                    <th>Reference</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedTransactions.map((transaction, index) => (
                    <tr key={index}>
                      <td>{transaction.id}</td>
                      <td>{transaction.network}</td>
                      <td>{transaction.receiver}</td>
                      <td>{transaction.offer}</td>
                      <td>&cent; {transaction.totalAmount}</td>
                      <td>{transaction.reference}</td>
                      <td>{transaction.date}</td>
                      <td>
                        {transaction.status === "pending" ? (
                          <Button
                            variant="warning"
                            size="sm"
                            className="w-100"
                            disabled
                          >
                            {transaction.status}
                          </Button>
                        ) : transaction.status === "rejected" ? (
                          <Button
                            variant="danger"
                            size="sm"
                            className="w-100"
                            disabled
                          >
                            {transaction.status}
                          </Button>
                        ) : (
                          <Button
                            variant="success"
                            size="sm"
                            className="w-100"
                            disabled
                          >
                            {transaction.status}
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between">
              <span>
                Showing {paginatedTransactions.length} of{" "}
                {filteredTransactions.length} entries
              </span>
              <Pagination>
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center mt-4">
          <h4>No records found</h4>
        </div>
      )}
    </Container>
  );
};

export default TransactionHistory;
